
<div class="modal-header d-block">
    <div class="d-flex">
      <p class="modal-title"><strong>Update  details</strong></p>
          <button type="button" (click)="close()" class="btn-close" aria-label="Close"></button>
    </div>
   
  </div>
  <div class="d-flex flex-column">
  <form [formGroup]="form"   class="mb-3">
    <formly-form [model]="model" [fields]="step"  [form]="form"></formly-form>
    <div class="d-flex justify-content-center" >
      <button class="btn btn-outline-primary me-2" (click)="close()">Close</button>
      <button  class="btn btn-secondary me-2" (click)="submit()" type="submit" [disabled]="!form.valid ">Update</button>
    </div>
  </form>
</div>